<template>
    <Link
        :href="href"
        :class="[
            'text-sm text-gray-500 hover:text-primary font-normal rounded-lg flex items-center p-2 hover:bg-gray-100 group',
            $page.props.route_name === route && 'bg-gray-100 text-primary-500',
        ]"
    >
        <Icon size="20">
            <slot
                :class="[
                    'w-6 h-6 text-gray-500 flex-shrink-0 group-hover:text-primary transition duration-75',
                    $page.props.route_name === route && 'text-primary-500',
                ]"
            ></slot>
        </Icon>
        <span
            :class="[
                'ml-3',
                $page.props.route_name === route
                    ? 'text-primary'
                    : 'text-gray-900',
            ]"
            >{{ title }}</span
        >
    </Link>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
    components: {
        Link,
        Icon,
    },
    props: {
        route: String,
    },
    data() {
        return {
            href: "/" + this.route,
            title: this.route.charAt(0).toUpperCase() + this.route.slice(1),
        };
    },
});
</script>
